import request from "../axios-instance";
import type { DisclosureDeadline } from "./types";

/**
 * 마감일이 YYYY-MM-DD 라는 계약을 경계에서 확인한다. 어긋난 값을 통과시키면 화면에
 * "D-NaN" 처럼 뜻 없는 날짜가 정상처럼 표시된다
 */
const checkedDeadline = (data: DisclosureDeadline): DisclosureDeadline => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(data?.deadline))
    throw new Error(
      `공시 마감일 형식이 YYYY-MM-DD 가 아닙니다: ${JSON.stringify(data?.deadline)}`,
    );
  return data;
};

export const getNextDisclosureDeadline =
  async (): Promise<DisclosureDeadline> => {
    const { data } = await request.get("/v1/disclosure-deadlines/next");
    return checkedDeadline(data);
  };

/** 서버가 GET next 와 같은 규칙으로 고른 회차의 마감일을 바꾼다 */
export const putNextDisclosureDeadline = async (
  deadline: string,
): Promise<DisclosureDeadline> => {
  const { data } = await request.put("/v1/disclosure-deadlines/next", {
    deadline,
  });
  return checkedDeadline(data);
};
